import { useEffect, useRef, useState } from "react";
import styleSheet from "./style.module.scss";
import SyOverlayContainer from "../../../../../shared/components/sy-overlay-container";
import SyPopup from "../../../../../shared/components/sy-model";
import { Fade } from "@mui/material";
import { useNavigate, useParams } from "react-router";
import SyFloatingContainer from "../../../../../shared/components/sy-floating-container";
import OrbButton from "../../../../../shared/components/orb-button";
import { tabconfig, tabview } from "../admin-config";
import CitizenInvitePop from "../../../popups/citizen-invite-popup";
import AdminStuffTable from "../admin-table-details";
import { AdminDetailsProps } from "../admin-interface";
import AdminTableDetals from "../admin-table-details";
import AdminPagination from "../admin-pagination";
import { useTranslation } from "react-i18next";
import OrbInput from "../../../../../shared/forms/orb-input";
import { Controller, useForm } from "react-hook-form";
import OrbSwitch from "../../../../../shared/forms/orb-switch";
import SyIcon from "../../../../../shared/components/sy-icon";
import orbitService from "../../../services/orbit-service";
import { useMutation } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { getOrbitDetails } from "../../../../../feature/orbit-slice";
import CitizenRequestPop from "../../../popups/citizen-request-popup";

const AdminDetails = (props: AdminDetailsProps) => {
  const {
    open,
    view,
    onClickTab,
    headerData,
    adminListData,
    pageIndex,
    pageSize,
    authDetails,
    onClickAction,
    updateAdminList,
  } = props;
  const navigate = useNavigate();
  const [openAddMember, setOpenAddMember] = useState<any>(false);
  const [openRequestPopup, setOpenRequestPopup] = useState<any>(false);
  const { t } = useTranslation();
    const { orbitId } = useParams();
  const orbitInfo = useSelector(getOrbitDetails);
  const isFirstRender = useRef(true);
  const getbuttonLabel = () => {
    return view?.id === tabview.planets.id
      ? t("new_planet")
      : t("invite_citizen");
  };

  const addDetails = (id: any) => {
    if (id === tabview.planets.id) {
      navigate(`/add/planet/${authDetails.orbit_details.orb_id}`);
    } else {
      setOpenAddMember(true);
    }
  };

  const openCitizenRequestPopup = () => {
    setOpenRequestPopup(true);
  };

  const closeCitizenRequestPopup = () => {
    setOpenRequestPopup(false);
    updateAdminList()
  };

  const openCloseAddMember = () => {
    setOpenAddMember(false);
  };

  const { mutate: getCitizenApprovalStatus } = useMutation({
    mutationFn: orbitService.getCitizenApprovalStatus,
    onSuccess(data, variables, context) {
      // setValue("approval", !!data?.data.orb_join_approval);
      setValue("approval", !!data?.data.orb_join_approval, {
        shouldDirty: true,
        shouldTouch: true,
        shouldValidate: true,
      });
    },
  });

  const { mutate: updateApprovalStatus } = useMutation({
    mutationFn: orbitService.updateApprovalStatus,
    onSuccess(data, variables, context) {},
  });
  const { control, handleSubmit, watch, setValue } = useForm({
    defaultValues: {
      approval: false },
  });

  const approval = watch("approval");

  useEffect(() => {
    if (isFirstRender.current) {
    isFirstRender.current = false;
    return;
   }

  
    const payload = {
      orb_id:orbitId,
      enabled: approval,
    };
    updateApprovalStatus(payload);
  }, [approval]);

  const getPopupComponents = () => {
    return (
      <>
        <SyPopup open={openAddMember} onClose={openCloseAddMember}>
          <CitizenInvitePop onClose={openCloseAddMember} />
        </SyPopup>
        <SyPopup
          maxWidth={"lg"}
          open={openRequestPopup}
          onClose={closeCitizenRequestPopup}
        >
          <CitizenRequestPop onClose={closeCitizenRequestPopup} />
        </SyPopup>
      </>
    );
  };

  useEffect(() => {
    getCitizenApprovalStatus(orbitId);
  }, []);

  //   getCitizenApprovalStatus(orbitInfo.selectOrbit);
  // }, [orbitInfo.selectOrbit]);

  return (
    <>
      <div className="row mt-4 ps-3 pe-4">
        <div className="col-12 ">
          <AdminPagination
            adminListData={adminListData}
            pageIndex={pageIndex}
            pageSize={pageSize}
            updateAdminList={updateAdminList}
          />
        </div>
        <div className="col-12">
          <Fade in={open} timeout={700}>
            <div className="d-flex flex-wrap row g-0 justify-content-between w-100 mb-3 ">
              <div className="col-md-6  col-sm-2">
                <p
                  className={`font-50 mb-1 text-white bebas-neue pointer truncate-1-lines`}
                >
                  {adminListData?.orb_name
                    ? adminListData?.orb_name
                    : adminListData?.orb_rand_name}
                </p>
                <p
                  className={`opacity-50 font-30 text-white mohave-bold pointer truncate-1-lines`}
                >
                  {adminListData?.orb_description}
                </p>
              </div>
              <div className="col-md-6 col-sm-10 ">
                <div
                  className={`${styleSheet.admin_tabs} d-flex justify-content-end w-100 mt-4 `}
                >
                  {tabconfig.map((data: any) => {
                    return (
                      <div className=" position-relative">
                        <div
                          className={`${
                            view?.label !== data.tab
                              ? "text-disabled"
                              : "text-white"
                          } ps-2 ${
                            data.tab !== tabview.volunteers.label
                              ? styleSheet.tab_border
                              : ""
                          } border-top-0 border-start-0 border-bottom-0 d-flex`}
                          onClick={() => onClickTab(data.tab)}
                          role="button"
                        >
                          <p className="mb-0  ">{t(data.tab)}</p>
                          <span
                            className={` ${styleSheet.tab_count} mx-2  rounded badge  text-white d-flex align-items-center`}
                          >
                            {data.tab === "planets"
                              ? adminListData?.planets?.length
                              : data.tab === "citizens"
                              ? adminListData?.citizens?.length
                              : adminListData?.volunteers?.length}
                          </span>
                        </div>
                      </div>
                    );
                  })}
                </div>

                <div className="p-2 d-flex justify-content-end mt-3 align-items-center">
                  {view?.id === tabview.citizens.id && (
                    <>
                      <form className="me-2 opacity-75">
                        <Controller
                          name="approval"
                          control={control}
                          render={({ field }) => (
                            <OrbSwitch
                              value={field.value}
                              onChange={field.onChange}
                              label={t('manual_approval')}
                            />
                          )}
                        />
                      </form>
                      <SyIcon
                        className="pe-2 pointer  opacity-75"
                        name={`pending`}
                        iconColor="white"
                        iconType="icons"
                        onClick={openCitizenRequestPopup}
                      />
                    </>
                  )}
                  {view?.id !== tabview.volunteers.id && (
                    <OrbButton
                      iconName="add"
                      iconColor="gray"
                      type="submit"
                      value={view?.id}
                      onBtnClick={addDetails}
                      label={getbuttonLabel()}
                      className={`${styleSheet.button}`}
                    />
                  )}
                </div>
              </div>
            </div>
          </Fade>
        </div>
        <div className="col-12 position-absolute bottom-0 pe-4">
          <SyOverlayContainer open={open}>
            <div className="pt-5 px-2 sy-scroll-x sy-scroll-y h-100 w-100">
              <AdminTableDetals
                mode={view.label}
                data={adminListData}
                onClickAction={onClickAction}
              />
            </div>
          </SyOverlayContainer>
        </div>
      </div>

      {getPopupComponents()}
    </>
  );
};
export default AdminDetails;
